import {
  updateWishlistBtns
} from '@components/wishlist';

const openModal = (modal) => {
  if (!modal) return;
  const foundModal =
    typeof modal === 'string' ? document.querySelector(modal) : modal;
  if (!foundModal) return;

  foundModal.style.display = 'block';
  document.querySelector('html').style.overflow = 'hidden';
  setTimeout(() => {
    window.requestAnimationFrame(() => {
      foundModal.classList.add('open');
      foundModal.style.display = '';
    });
  }, 100);
  updateWishlistBtns();
};

const closeModal = (modal) => {
  if (!modal) return;
  const foundModal =
    typeof modal === 'string' ? document.querySelector(modal) : modal;
  if (!foundModal) return;

  const transitionDuration =
    parseFloat(
      getComputedStyle(foundModal).transitionDuration.replace('s', ''),
    ) * 1000;
  foundModal.style.display = 'block';
  window.requestAnimationFrame(() => {
    foundModal.classList.remove('open');
    if (foundModal.id == '#modal-size') {
      let productInfoContainer = foundModal.closest('.product-page__info');
      productInfoContainer.style.zIndex = 'unset';
    }
    setTimeout(() => {
      foundModal.style.display = '';
      document.querySelector('html').style.overflow = '';
    }, transitionDuration);
  });
};

const initModals = (root = document) => {
  if (!root) return;
  const rootEl = typeof root === 'string' ? document.querySelector(root) : root;
  if (!rootEl) return;

  document.querySelectorAll('.modal').forEach((modal) => {
    modal
      .querySelectorAll('.modal__backdrop , .modal__close , .modal__close_trigger')
      .forEach((closer) =>
        closer.addEventListener('click', () => {
          if (modal.id == 'modal-size') {
            const productInfoContainer = modal.closest('.product-page__info');
            if (productInfoContainer) {
              productInfoContainer.style.zIndex = 'unset';
            }
          }
          closeModal(modal);
        }),
      );
    if (modal.id)
      rootEl.querySelectorAll(`a[href*="${modal.id}"]`).forEach((btn) =>
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const sizeSelectorTarget = e.target.closest(
            '.product-page__option--size-selected',
          );
          if (
            btn.classList.contains('product-page__option--size') ||
            btn.classList.contains('btn-select-size') ||
            sizeSelectorTarget
          ) {
            const productInfoContainer = btn.closest('.product-page__info');
            if (productInfoContainer) {
              productInfoContainer.style.zIndex = '4';
            }
          }
          openModal(modal);
        }),
      );
  });
};

export { initModals, openModal, closeModal };
